export const uiTestMenuI18n = {
  uiTest: 'DEV TEST',
  uiTestPage: {
    title: 'DEV TEST',
    description:
      'Runs on the real business URL with real user interactions. Returns here with results when finished.',
    scenarioNhomKhachHang: 'TEST customer groups ({count} features)',
    scenarioNhomKhachHangHint:
      'Real screen — reads DB, creates 2 unique groups per run, search/edit/delete from current data.',
    runButton: 'Run',
    runAllButton: 'Start ALL',
    runGroupButton: 'Run group',
    runNewTabButton: 'New tab',
    groupCount: '{n} scenarios',
    runningOnPage: 'Running test on the real screen…',
    runningLiveBanner: 'UI action test in progress — will return here when done',
    runningLiveBannerAll:
      'Start ALL — scenario {current}/{total} — will return here when finished',
    runAllResultTitle: 'Start ALL results',
    runAllResultSuccess: 'Completed {n} scenarios — all passed',
    runAllResultPartial: 'Completed {n} scenarios — {failed} scenario(s) failed',
    runAllScenarios: 'Scenarios: {n}',
    runAllScenarioList: 'Per scenario',
    runTitleNhomKhachHang: 'Customer group TEST results',
    back: 'Back to test list',
    running: 'Running',
    done: 'Done',
    logTitle: 'Detailed log',
    featureTitle: 'Per feature',
    resultModalTitle: 'UI action test results',
    resultSuccess: 'Success',
    resultPartial: 'Partially completed',
    resultFailed: 'Failed',
    resultPassed: 'Passed: {n}',
    resultSkipped: 'Skipped: {n}',
    resultFailedCount: 'Failed: {n}',
    resultTotal: 'Total: {n}',
    resultClose: 'Close',
    failed: 'UI action test failed',
    unknownScenario: 'Unknown test scenario',
    importFilesSection: 'Download import test files',
    importFilesSectionHint:
      'Build Excel from live data (all products × current price books) for import trials.',
    importFilesDownload: 'Download',
    importFilesDownloading: 'Building…',
    importFilesSuccess: 'Downloaded {file} ({rows} rows × {books} price books)',
    importFilesFailed: 'Could not build import test file',
    importFiles: {
      bangGiaHangHoaTitle: 'Import product price books',
      bangGiaHangHoaHint:
        'Matrix: one product code per row; columns from 3rd = current price book names; invented test prices.',
    },
  },
} as const
